"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var textAlignMap = {
    center: 'center',
    left: 'left',
    right: 'right',
    justify: 'justify',
};
// eslint-disable-next-line no-confusing-arrow
exports.default = (function (_a) {
    var textAlign = _a.textAlign;
    return textAlign in textAlignMap ? "text-align: " + textAlignMap[textAlign] + ";" : '';
});
